define.alias("ember-math-helpers/helpers/cosh", "settings/helpers/cosh");